// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__1YME2","inputSearch":"Search_inputSearch__ypMd7"};